import CashOrder from '@/factory/cash_order'

export default {
  setPaymentRequests(state, value) {
    state.paymentRequests = value
  },
  setPaymentRequestCounter(state, value) {
    state.paymentRequestCounter = value
  },
  updatePaymentRequests(state, value) {
    state.paymentRequests = state.paymentRequests.concat(value)
  },
  setPaymentRequestFilters(state, value) {
    state.paymentRequestFilters = value
  },
  setCashOrders(state, value) {
    state.cashOrders = value
  },
  setCashCounter(state, value) {
    state.cashCounter = value
  },
  setCashSummary(state, value) {
    state.cashSummary = value
  },
  setOrders(state, value) {
    state.orders = value
  },
  setCertifications(state, value) {
    state.certifications = value
  },
  setCashOrder(state, value) {
    state.cashOrder = value
  },
  setOrder(state, value) {
    state.cashOrder = value
  },
  setOrderHistory(state, value) {
    state.orderHistory = value
  },
  setOrderStatuses(state, value) {
    state.orderStatuses = value
  },
  setPaymentStatuses(state, value) {
    state.paymentStatuses = value
  },
  setPaymentTypes(state, value) {
    state.paymentTypes_get = value
  },
  setOrdersCounter(state, value) {
    state.ordersCounter = value
  },
  setOrdersSummary(state, value) {
    state.ordersSummary = value
  },
  setCashOrdersOperations(state, value) {
    state.operations = value
  },
  setCashOrdersBasis(state, value) {
    state.basis = value
  },
  updateCashOrders(state, value) {
    state.cashOrders = state.cashOrders.concat(value)
  },
  updateOrders(state, value) {
    state.orders = state.orders.concat(value)
  },
  updateCertifications(state, value) {
    state.certifications = state.certifications.concat(value)
  },
  updateSalaries(state, value) {
    state.salaries = state.salaries.concat(value)
  },
  setSalaries(state, value) {
    state.salaries = value
  },
  deleteItemSalary(state, value) {
    state.salaries.splice(value.index, 1)
  },
  setSalary(state, value) {
    state.salary = value
  },
  clearCashOrder(state) {
    state.cleanCashOrder = CashOrder.create()
  },
  setOrderFilters(state, value) {
    state.orderFilters = value
  },
  setCashOrdersFilters(state, value) {
    state.cashOrdersFilters = value
  },
  setCertificateFilters(state, value) {
    state.certificateFilters = value
  },
  setCertificateListFilters(state, value) {
    state.certificateListFilters = value
  },
}
